//Utilities
var EventEmitter = require('events').EventEmitter;
var assign = require('object-assign');
var _ = require('lodash');
var Validators = require('../utils/Validators.js');

//Component
var AppDispatcher = require('../core/AppDispatcher.jsx');
var Constants = require('../constants/RegularInvestmentPlanConstants.js');

//constants
var ProductIds = require('../constants/ApplicationConstants').ProductIds;
var ApplicationConstants = require('../constants/ApplicationConstants.js');
var Mapper = require('../utils/Mapper.js');
var Formatter = require('../utils/Formatter.js');
var DateTime = require('../utils/DateTime.js');
var ContentService = require('../services/ContentService.js');
var CHANGE_EVENT = 'change';
var _model = Constants.RegularInvestmentPlanData;
var _formError = Constants.RegularInvestmentPlanErrorState;
var ActionTypes = Constants.ActionTypes;
var FundingConstants = require('../constants/FundingYourProductConstants.js');
// cross section dependency
var SelectCustomerActionsTypes = require('../constants/SelectCustomerConstants.js').ActionTypes;
var _client;

//local variables
var _invtAllocationAreInSync = true,
    _originalInvestmentAllocationList = [],
    _isYourDetailsAgeEligibilityFirstSync = true,
    _yourDetailsAreInSync = true,
    _originalYourDetailsDob,
    _yourDetialsDob,
    _age,
    _setupError = true,
    _eligibleContribution = { hidePersonal: true, hideSpouse: true },
    _errorListForSummary = [],
    _specificBankAccounts = [],
    _showBankAccountList = false,
    _productId,
    _showRipSection = true,
    _hasTermDeposit = false,
    _hasFixRate = false,
    _bankData = [],
    _internalBankData = [],
    _bankAccountFunding = '',
    _hasDeposits = false,
    _prevOriginalInvestmentAllocationList = [],
    _userType,
    _accountType;

// model attributes
var _customAttributeName = {
    personalContribution: 'Personal contribution amount per month',
    spouseContribution: 'Spouse contribution amount per month',
    monthlyAmountContribution: 'Monthly amount',
    selectedBankAccount: 'Specify one bank account',
    nameOfAccountHolder: 'Name of account holder',
    bankAccountHeldOption: 'Provide information about your bank account',
    branchNumber: 'Branch number (BSB)',
    bankAccount: 'Account number',
    consumerPriceIndex: 'Select if you want a your regular amount increased'
}

//map from model to Id
var _mapModelToFieldId = {
    personalContribution: 'ripPersonalContributionText',
    spouseContribution: 'ripSpouseContributionText',
    totalContribution: 'ripContributionSection',
    monthlyAmountContribution: 'ripMonthlyAmountContributionText',
    selectedBankAccount: 'ripBankAccountsList',
    nameOfAccountHolder: 'ripNameOfAccountHolderText',
    bankAccountHeldOption: 'ripBankAccountHeldOption',
    branchNumber: 'ripBranchNumberText',
    bankAccount: 'ripBankAccountText',
    specifyBankAccountEntry: 'ripNominatedOtherAccount',
    investmentOptionList: Constants.RIP_INV_OPT_PREFIX,
    totalAllocationPercentage: 'ripTotalAllocationPercentage',
    consumerPriceIndex: 'ripConsumerPriceIndexOption'
};

//map from Id to model
var _unMapModelToFieldId = {
    ripPersonalContributionText: 'personalContribution',
    ripSpouseContributionText: 'spouseContribution',
    ripContributionSection: 'totalContribution',
    ripMonthlyAmountContributionText: 'monthlyAmountContribution',
    ripBankAccountsList: 'selectedBankAccount',
    ripNameOfAccountHolderText: 'nameOfAccountHolder',
    ripBankAccountHeldOption: 'bankAccountHeldOption',
    ripBranchNumberText: 'branchNumber',
    ripBankAccountText: 'bankAccount',
    ripNominatedOtherAccount: 'specifyBankAccountEntry',
    ripInvstOption: 'investmentOptionList',
    ripTotalAllocationPercentage: 'totalAllocationPercentage',
    ripConsumerPriceIndexOption: 'consumerPriceIndex'
};

function setClient(client) {
    _client = _.cloneDeep(client);
}

function prePopulateWithExistingClientIfAny() {
    if (!_client) {
        return;
    }

    // set date of birth
    if ((_productId === ApplicationConstants.ProductIds.SUPER || _productId === ApplicationConstants.ProductIds.PENSION)
        && _client.customerType === ApplicationConstants.ClientTypes.INDIVIDUAL) {
        setOriginalYourDetailsAgeEligibility(_client.dateOfBirth);
    }
}

//model validation rules
function getRules() {
    var rules = {
        personalContribution: 'currency|currencyMaxLength',
        spouseContribution: 'currency|currencyMaxLength',
        monthlyAmountContribution: 'required|currency|amountPerMonthLessThan100|currencyMaxLength',
        selectedBankAccount: 'required',
        nameOfAccountHolder: 'nameWithNumSpaces|maxLength:30',
        branchNumber: 'numeric2|exactLength:6',
        bankAccount: 'alphaNumWithSpaces|maxLength:9'
    };

    if (_productId !== ProductIds.INVESTMENT) {
        delete rules.monthlyAmountContribution;
    }

    if (_model.selectedBankAccount !== Constants.NOMINATE_OTHER_ACCOUNT) {
        delete rules.nameOfAccountHolder;
        delete rules.branchNumber;
        delete rules.bankAccount;
        delete rules.selectedBankAccount;
    } else {
        delete rules.selectedBankAccount;
    }

    return rules;
}

//validation rules
function getValidationRules(fieldId) {
    var allRules = getRules();

    if (!fieldId) {
        return allRules;
    }

    if (!allRules[fieldId]) {
        return null;
    }

    var rulesForField = {};
    rulesForField[fieldId] = allRules[fieldId];
    return rulesForField;
}

//Map the inline & summary error because the model doesn't much the Id
function mapInlineErrors(errorList, mapType) {
    if (errorList.length > 0) {
        _.forEach(errorList, function (n) {
            if (!_.startsWith(n.id, Constants.RIP_INV_OPT_PREFIX)) {
                n.id = mapType === 'Id' ? _mapModelToFieldId[n.id] : _unMapModelToFieldId[n.id];
            }
        });
    }
    return errorList;
}

//Method to update you model
function updateRegularInvestmentPlan(data) {
    if (data) { Mapper.objectMerger(_model, data); }
}

//this method is to get the model and display it to the view
function getModelData() {
    return _.cloneDeep(_model);
}

function validateFields(fieldName, fieldValue) {
    var rules = getValidationRules(fieldName),
        errors = mapInlineErrors(_formError.errorList, 'model'),
        data = {};

    data[fieldName] = fieldValue;

    Validators.validateField(data, rules, _customAttributeName, errors, fieldName);

    _formError.errorList = mapInlineErrors(errors, 'Id');

    validateForm();
}

//Generate Inline and summary message error.
function throwErrorMessage(id, inlineMsg, summaryMsg) {

    var copytextRip = ContentService.getContent().regularInvestmentPlan;

    if (inlineMsg) {

        _formError.errorList.push({ id: id, message: inlineMsg, type: 'error' });
    }

    if (summaryMsg) {

        _errorListForSummary.push({ id: id, message: summaryMsg, clickable: copytextRip.regularInvestmentPlanSection });
    }
}

//Validate investment option qty in RIP
function validateInvestmentOptionQty() {
    var copytextRip = ContentService.getContent().regularInvestmentPlan;
    var qty = [];

    _model.totalAllocationPercentage = '0.00';

    //We need to remove any existing investment Ids
    _.remove(_formError.errorList, function (n) { return _.startsWith(n.id, Constants.RIP_INV_OPT_PREFIX); });
    _.remove(_errorListForSummary, function (n) { return _.startsWith(n.id, Constants.RIP_INV_OPT_PREFIX); });

    _.forEach(_model.investmentOptionList, function (o, i) {
        var code = o.code + ' - ';

        if (o.weight) {
            if (!Validators.currencyValidation(o.weight)) {

                o.isValid = false;

                throwErrorMessage(Constants.RIP_INV_OPT_PREFIX + i, Formatter.formatString(copytextRip.investAllocationInline, { code: code }),
                        Formatter.formatString(copytextRip.investAllocationSummary, { code: code }));

            } else {
                o.weight = Formatter.currencyFormatWithoutRounding(o.weight);

                if (Formatter.currencyUnformat(o.weight).length > 6 || Formatter.currencyUnformat(o.weight) > 100) {

                    o.isValid = false;
                    throwErrorMessage(Constants.RIP_INV_OPT_PREFIX + i, Formatter.formatString(copytextRip.investPercentExceedInline, { code: code }),
                            Formatter.formatString(copytextRip.investPercentExceedSummary, { code: code }));

                } else {
                    o.isValid = true;
                    qty.push(Formatter.currencyUnformat(o.weight));
                }
            }
        } else {
            o.isValid = true;
        }
    });

    var sumInvestmentAllocationWeight = _.round(_.sum(qty), 2);
    _model.totalAllocationPercentage = Formatter.currencyFormatWithoutRounding(sumInvestmentAllocationWeight);

    validateExcludeInvestments();
}

//Validate investment option summary in RIP
function validateInvestmentOptionSummary() {

    var copytextRip = ContentService.getContent().regularInvestmentPlan;
    var sumInvestmentAllocationWeight = _.round(_model.totalAllocationPercentage, 2);

    var checkForErrors = _.filter(_formError.errorList, function (n) { return _.startsWith(n.id, Constants.RIP_INV_OPT_PREFIX); })
    if (checkForErrors.length === 0) {

        //M12-validate if weight is less than 100%
        if (sumInvestmentAllocationWeight > 0 && sumInvestmentAllocationWeight < 100 || sumInvestmentAllocationWeight > 100) {

            var invest100HasError = _.filter(_formError.errorList, { message: copytextRip.investAllocation100Inline });

            if (invest100HasError.length === 0) {

                throwErrorMessage(Constants.RIP_INV_OPT_PREFIX + 0, copytextRip.investAllocation100Inline, copytextRip.investAllocation100Summary);
            }
        } else if (sumInvestmentAllocationWeight === 0) { //Check if investment allocation is empty

            var investIsEmpty = _.filter(_formError.errorList, { message: copytextRip.investPercentEmptyInline });
            if (investIsEmpty.length === 0) {

                throwErrorMessage(Constants.RIP_INV_OPT_PREFIX + 0, copytextRip.investPercentEmptyInline, copytextRip.investPercentEmptySummary);
            }
        }
    }

    validateExcludeInvestments();
}

function validateExcludeInvestments() {
    /*M8-Excluded investments - 
    Any allocations you have made to FirstRate Term Deposits or FirstRate Investment Deposit options 
    will be re-allocated to other options on a pro-rata basis for your regular investment plan. */
    if (_model.sameAsInvestAllocationOption === ApplicationConstants.YesNoValues.YES &&
        (_hasFixRate || _hasTermDeposit)) {

        _formError.excludedInvestment = false;
    } else {
        _formError.excludedInvestment = true;
    }
}

//Validate the fields
function validateForm() {
    //RIP option is not valid
    if (!_setupError) {
        return;
    }

    var copytextRip = ContentService.getContent().regularInvestmentPlan;
    var personalEligible = _eligibleContribution.hidePersonal,
        spouseEligible = _eligibleContribution.hideSpouse,
        accountNumberHasError = _.filter(_formError.errorList, { id: 'ripBankAccountText' });

    _model.totalContribution = '0.00';

    //check if your details age is updated
    if (!_yourDetailsAreInSync && _model.ripOption === ApplicationConstants.YesNoValues.YES) {
        if (!_originalYourDetailsDob) {
            throwErrorMessage('regularInvestPlanOption', copytextRip.missingDOBInline, copytextRip.missingDOBSummary);
        }
    } else {
        _.remove(_formError.errorList, { id: 'regularInvestPlanOption' });
    }

    //check if investment option is updated
    if (_yourDetailsAreInSync && !_invtAllocationAreInSync && _model.ripOption === ApplicationConstants.YesNoValues.YES) {
        _formError.investmentOptionsAreOutOfSyncCopy = false;

        throwErrorMessage('regularInvestPlanSetup', '', copytextRip.investmentOptionsAreOutOfSyncCopyHeading.toLowerCase());
    } else {
        _formError.investmentOptionsAreOutOfSyncCopy = true;
    }

    var contribution = [];
    var totalContribution;

    if (!personalEligible) {
        if (_model.personalContribution.length > 0 && Validators.currencyValidation(_model.personalContribution)) {
            _model.personalContribution = Formatter.currencyFormatWithoutRounding(_model.personalContribution);

            if (Validators.isCurrencyMaxLength(_model.personalContribution)) {
                contribution.push(Formatter.currencyUnformat(_model.personalContribution));
            }
        }
    }

    if (!spouseEligible) {
        if (_model.spouseContribution.length > 0 && Validators.currencyValidation(_model.spouseContribution)) {
            _model.spouseContribution = Formatter.currencyFormatWithoutRounding(_model.spouseContribution);

            if (Validators.isCurrencyMaxLength(_model.spouseContribution)) {
                contribution.push(Formatter.currencyUnformat(_model.spouseContribution));
            }
        }
    }

    totalContribution = _.round(_.sum(contribution), 2);

    _model.totalContribution = Formatter.currencyFormatWithoutRounding(totalContribution);

    if (_productId === ProductIds.INVESTMENT) {
        if (_model.monthlyAmountContribution.length > 0 && Validators.currencyValidation(_model.monthlyAmountContribution)) {
            _model.monthlyAmountContribution = Formatter.currencyFormatWithoutRounding(_model.monthlyAmountContribution);
        }
    }

    if (_productId === ProductIds.SUPER) {

        //M3-Validate if the contribution is less than 100 or exceed max length
        _.remove(_formError.errorList, { message: copytextRip.monthlyContribution100Inline });
        _.remove(_formError.errorList, { message: copytextRip.monthlyContributionEmptyInline });

        var personalHasError = _.filter(_formError.errorList, { id: 'ripPersonalContributionText' });
        var spouseHasError = _.filter(_formError.errorList, { id: 'ripSpouseContributionText' });

        if (personalHasError.length === 0 && spouseHasError.length === 0) {

            var sumMonthlyContribution = _.sum([Formatter.currencyUnformat(_model.totalContribution)]);

            if (sumMonthlyContribution > 0 && sumMonthlyContribution < 100) {

                throwErrorMessage('ripContributionSection', copytextRip.monthlyContribution100Inline, copytextRip.monthlyContribution100Summary);

            } else if (sumMonthlyContribution === 0) {

                throwErrorMessage('ripContributionSection', copytextRip.monthlyContributionEmptyInline, copytextRip.monthlyContributionEmptySummary);

            }
        }
    }

    //M4-Future requests    
    _formError.accountNumberFutureRequest = accountNumberHasError.length <= 0;

    //M4-Future requests reset
    if (_model.selectedBankAccount === Constants.NOMINATE_OTHER_ACCOUNT && _model.bankAccount) {
        _formError.accountNumberFutureRequest = false;

        if (_model.bankAccountHeldOption && _model.bankAccountHeldOption.length !== 0) {
            _.remove(_formError.errorList, { id: 'ripBankAccountHeldOption' });
            _.remove(_errorListForSummary, { id: 'ripBankAccountHeldOption' });
        }
    }

    //Selected bank account
    if (_model.selectedBankAccount && _model.selectedBankAccount.length > 0) {
        _.remove(_formError.errorList, { id: 'ripBankAccountsList' });
        _.remove(_errorListForSummary, { id: 'ripBankAccountsList' });
        _formError.listBankAccountRequiredValid = true;
    }

    //Consumer price index
    if (_model.consumerPriceIndex && _model.consumerPriceIndex.length !== 0) {
        _.remove(_formError.errorList, { id: 'ripConsumerPriceIndexOption' });
        _.remove(_errorListForSummary, { id: 'ripConsumerPriceIndexOption' });
    }
}

//Upon clicking Yes, this method validate the necessary errors
function validateRegularInvestmentPlan(ripOption, productId, userType, accountType) {
    _errorListForSummary = [];
    _productId = productId;
    _userType = userType;
    _accountType = accountType;

    var investmentlist = _originalInvestmentAllocationList,
        investmentlistLength = investmentlist.length,
        investmentAllocationGetPercentage = 0,
        termDeposit, firstRateInvestment, isInvestAllocationTerminDepositAndFirtRate = false,
        copytextRip = ContentService.getContent().regularInvestmentPlan;

    if (ripOption === ApplicationConstants.YesNoValues.YES) {

        updateRegularInvestmentPlan({ ripOption: ApplicationConstants.YesNoValues.YES });
        createTableBankAccounts();
        if (investmentlistLength > 0) {

            investmentAllocationGetPercentage = _.sum(investmentlist, function (data) { return parseFloat(data.weight) });
            investmentAllocationGetPercentage = Formatter.roundToTwo(investmentAllocationGetPercentage);
            termDeposit = _.filter(investmentlist, { termDeposit: true }); //Identify if investment option item is term deposit

            firstRateInvestment = _.filter(investmentlist, { isFirstRateInvestment: true }); //Identify if investment option list is first rate

            _hasTermDeposit = termDeposit.length > 0,
            _hasFixRate = firstRateInvestment.length > 0;

            if (termDeposit || firstRateInvestment) { //compare the length of items if all are valid to first rate or term deposit
                var countFirstRateAndTermDeposit = termDeposit.length + firstRateInvestment.length;
                isInvestAllocationTerminDepositAndFirtRate = Boolean(countFirstRateAndTermDeposit === investmentlistLength);
            }
        }

        if (!validateDob(_originalYourDetailsDob, productId) && productId === ProductIds.SUPER) { //M10-verify if DOB is defined
            _setupError = false;

            throwErrorMessage('regularInvestPlanOption', copytextRip.missingDOBInline, copytextRip.missingDOBSummary);

        } else if (investmentlistLength === 0) { //Verify if investment option is not empty
            _setupError = false;

            throwErrorMessage('regularInvestPlanOption', copytextRip.noInvestmentAllocationInline, copytextRip.investAllocationSetupSummary);

        } else if (investmentAllocationGetPercentage !== 100) { //M12-Verify if investment option is equal to 100%
            _setupError = false;

            throwErrorMessage('regularInvestPlanOption', copytextRip.not100PercentInvestAllocationInline, copytextRip.investAllocation100Summary);

        } else if (isInvestAllocationTerminDepositAndFirtRate) {//M9-Verify if not term deposit or First rate
            _setupError = false;

            throwErrorMessage('regularInvestPlanOption', copytextRip.investAllocationOtherThanTermDepositInline, copytextRip.investAllocationSetupSummary);

        } else { //Successfully
            _setupError = true;

            loadInvestmentOptionList();

            if (productId === ProductIds.SUPER) {
                loadDob(_originalYourDetailsDob);
                setAgeEligibility(_age);
            }

            setSpecificBankAccounts(userType, productId, accountType);
        }
    } else {
        //Reset all values to its normal state when the user clicks NO
        resetRipModel(ApplicationConstants.YesNoValues.NO);

        //reset form error required field
        _.forEach(_formError, function (value, key) {
            if (key !== 'errorList') {
                _formError[key] = true;
            }
        });

        _setupError = true;        
        _isYourDetailsAgeEligibilityFirstSync = true;
        _yourDetailsAreInSync = true;
        _invtAllocationAreInSync = true;
        _formError.errorList = [];
    }
}

//Validate required fields mandatory upon submission
function validateRequiredFields() {
    var data = _model;
    var copytextRip = ContentService.getContent().regularInvestmentPlan;

    if (_setupError && data.ripOption === ApplicationConstants.YesNoValues.YES) {
        _formError.errorList = [];
        _errorListForSummary = [];

        _.remove(_formError.errorList, { id: 'ripBankAccountsList' });

        _formError.listBankAccountRequiredValid = true;

        if (_model.selectedBankAccount === Constants.NOMINATE_OTHER_ACCOUNT) {

            _formError.specifyBankAccountValid = true;

            _.remove(_errorListForSummary, { message: copytextRip.listBankAccountSummary });

        } else {
            if (_model.selectedBankAccount.length === 0) {
                _formError.listBankAccountRequiredValid = false;

                throwErrorMessage('ripBankAccountsList', '', copytextRip.listBankAccountSummary);
            }
        }

        if (!_model.consumerPriceIndex || _model.consumerPriceIndex.length === 0) {

            throwErrorMessage('ripConsumerPriceIndexOption', copytextRip.consumerPriceIndexInline, copytextRip.consumerPriceIndexSummary);
        }

        var inlineErrorList = Validators.validateAll(_model, getRules(), _customAttributeName);
        var summary = Validators.validateAll(_model, getRules(), _customAttributeName, '', copytextRip.regularInvestmentPlanSection);

        _formError.errorList = _formError.errorList.concat(mapInlineErrors(inlineErrorList, 'Id'));

        validateForm();
        validateInvestmentOptionQty();
        validateInvestmentOptionSummary();

        var summaryList = _errorListForSummary.concat(mapInlineErrors(summary, 'Id'));
        var tempSummaryList = [];

        //We need to sort the summary list.
        _.forEach(_mapModelToFieldId, function (value) {
            var result = _.filter(summaryList, function (o) { return o.id.toString().indexOf(value) > -1 });

            if (result.length === 1) { //for single entry

                if (result[0].id === 'ripNominatedOtherAccount') {

                    result[0].id = 'ripNameOfAccountHolderText';
                } else if (result[0].id === 'ripContributionSection') {

                    result[0].id = 'ripPersonalContributionText';
                }

                tempSummaryList.push(result[0]);

            } else if (result.length > 1) { //for repeating section of RIP investment option

                _.forEach(result, function (o) {

                    tempSummaryList.push(o);
                });
            }
        });

        if (_.findIndex(summaryList, 'id', 'regularInvestPlanOption') > -1) {
            resetRipModel(ApplicationConstants.YesNoValues.YES);
            throwErrorMessage('regularInvestPlanOption', copytextRip.missingDOBInline, copytextRip.missingDOBSummary);
            tempSummaryList = [];
            tempSummaryList.push(_.find(_errorListForSummary, 'id', 'regularInvestPlanOption'));
            _setupError = false;
        }

        _errorListForSummary = tempSummaryList;

    } else if (!data.ripOption && _showRipSection && (_productId === ProductIds.SUPER || _productId === ProductIds.INVESTMENT)) {

        throwErrorMessage('regularInvestPlanOption', copytextRip.ripNotSelectionInline, '');

        _setupError = false;

        var isNotSelected = _.filter(_errorListForSummary, { message: copytextRip.ripNotSelectionSummary });
        if (isNotSelected.length === 0) {

            throwErrorMessage('regularInvestPlanOption', '', copytextRip.ripNotSelectionSummary);
        }
    }
}

//We make sure that all onload validation are pass
function loadInvestmentOptionList() {
    generateRIPInvestmentOptionList();
    _prevOriginalInvestmentAllocationList = _.cloneDeep(_originalInvestmentAllocationList);
}

//We make sure that all onload validation are pass
function loadDob(data) {
    if (_setupError && _model.ripOption === ApplicationConstants.YesNoValues.YES) {
        if (_isYourDetailsAgeEligibilityFirstSync) {
            _yourDetialsDob = _.clone(data);
            _isYourDetailsAgeEligibilityFirstSync = false;
        } else {
            _yourDetailsAreInSync = _.isEqual(_originalYourDetailsDob, _yourDetialsDob);
        }
    }
}

//Generate investment option list
function generateRIPInvestmentOptionList() {
    var filteredList = [];

    _.forEach(_originalInvestmentAllocationList, function (o) {
        if (!o.termDeposit && !o.isFirstRateInvestment) {
            var data = { code: o.code, id: o.id, name: o.name, origWeight: o.weight, isValid: true };
            var existingInvestmentOption = _.find(_model.investmentOptionList, 'id', o.id);
            data.weight = existingInvestmentOption? existingInvestmentOption.weight : '';
            filteredList.push(data);
        }
    });

    _hasDeposits = _originalInvestmentAllocationList.length !== filteredList.length;
    _formError.excludedInvestment = _model.sameAsInvestAllocationOption === ApplicationConstants.YesNoValues.YES && _hasDeposits? false : true;

    updateRegularInvestmentPlan({ investmentOptionList: '' }); //reset

    updateRegularInvestmentPlan({ investmentOptionList: filteredList });
}

//Generate monthly allocation has been selected then distribute the weight
function monthlyAmountAllocation(option) {
    if (option === ApplicationConstants.YesNoValues.YES) {
        if (_hasDeposits) {
            var base = _.sum(_model.investmentOptionList, function (o) { return o.origWeight });

            _.forEach(_model.investmentOptionList, function (o) {
                var w = o.origWeight / (base) * 100;
                o.weight = (Math.floor(w * 100) / 100).toFixed(2).toString();
                o.isValid = true;
            });

            var total = _.sum(_model.investmentOptionList, function (t) { return t.weight });

            if (total !== 100) {
                var less = 100 - total;

                if (less > 0) {
                    var lastIndex = _.last(_model.investmentOptionList);
                    var addUpValue = parseFloat(lastIndex.weight) + parseFloat(less.toFixed(2));
                    lastIndex.weight = addUpValue.toFixed(2);
                }
            }

            updateRegularInvestmentPlan({ totalAllocationPercentage: Formatter.currencyFormatWithoutRounding(_.sum(_model.investmentOptionList, function (t) { return t.weight })) });
            _.remove(_formError.errorList, function (o) {  return _.startsWith(o.id, Constants.RIP_INV_OPT_PREFIX); });
        } else {
            _.forEach(_model.investmentOptionList, function (o) { o.weight = o.origWeight; });

            updateAndCheckForTotalAllocation();
        }
    } else {
        _.forEach(_model.investmentOptionList, function (o) {
            o.weight = '';
            o.isValid = true;
        });
        updateRegularInvestmentPlan({ totalAllocationPercentage: '0.00' });
        _.remove(_formError.errorList, function (o) {  return _.startsWith(o.id, Constants.RIP_INV_OPT_PREFIX); });
    }       

    updateRegularInvestmentPlan({ sameAsInvestAllocationOption: option });

    _formError.excludedInvestment = _model.sameAsInvestAllocationOption === ApplicationConstants.YesNoValues.YES && _hasDeposits? false : true;
}

function updateAndCheckForTotalAllocation() {
    var copytextRip = ContentService.getContent().regularInvestmentPlan,
        total = Formatter.currencyFormatWithoutRounding(_.round(_.sum(_model.investmentOptionList, function (t) { return t.weight }), 2));

    updateRegularInvestmentPlan({ totalAllocationPercentage: total });

    _.remove(_formError.errorList, function (o) {  return _.startsWith(o.id, Constants.RIP_INV_OPT_PREFIX); });
    if (total !== '100.00') {
        throwErrorMessage(Constants.RIP_INV_OPT_PREFIX + 0, copytextRip.investAllocation100Inline);
    }
}

function setBankAccountsList(fundingSummary) {
    _bankAccountFunding = '';
    var dd = _.find(fundingSummary, { paymentMethod: FundingConstants.ContributionValues.DIRECT_D });
    //if partial values are available, treat them as complete
    if ((dd && dd.accountNumber) || (dd && dd.accountHolderName) || (dd && dd.branchNumber)) {
        _bankAccountFunding = dd;
    }
}

function setSpecificBankAccounts(userType, productID, accountType) {
    if (_bankData.length > 0 && userType === ApplicationConstants.UserTypes.INVESTOR) {
        //show bank accounts only if
        if (productID === ProductIds.SUPER || (productID === ProductIds.INVESTMENT && (accountType === ApplicationConstants.AccountTypeCodes.INDIVIDUAL || accountType === ApplicationConstants.AccountTypeCodes.PARTNERSHIP))) {
            _showBankAccountList = true;
        }
    }

    if (!_showBankAccountList) {
        updateRegularInvestmentPlan({ selectedBankAccount: Constants.NOMINATE_OTHER_ACCOUNT }); //we need to update the bank account to show only nominated account
    }
}

//Reset all values to its normal state 
function resetRipFormModel(){
    updateRegularInvestmentPlan({
        personalContribution: '',
        spouseContribution: '',
        monthlyAmountContribution: '',
        selectedBankAccount: '',
        nameOfAccountHolder: '',
        bankAccountHeldOption: '',
        branchNumber: '',
        bankAccount: '',
        sameAsInvestAllocationOption: '',
        investmentOptionList: [],
        consumerPriceIndex: '',
        totalContribution: '0.00',
        totalAllocationPercentage: '0.00'
    });

    _.remove(_errorListForSummary, function(o){ return o.id !== 'regularInvestPlanOption' });
    _.remove(_formError.errorList, function(o){ return o.id !== 'regularInvestPlanOption' });
}
function resetRipModel(setRipOption) {
    updateRegularInvestmentPlan({
        ripOption: setRipOption,
        personalContribution: '',
        spouseContribution: '',
        monthlyAmountContribution: '',
        selectedBankAccount: '',
        nameOfAccountHolder: '',
        bankAccountHeldOption: '',
        branchNumber: '',
        bankAccount: '',
        sameAsInvestAllocationOption: '',
        investmentOptionList: [],
        consumerPriceIndex: '',
        totalContribution: '0.00',
        totalAllocationPercentage: '0.00'
    });

    _setupError = true;
    _errorListForSummary = [];
    _formError.errorList = [];
}

//update the weight for each investment item
function updateRIPInvestAllocationQty(index, weight) {

    var idx = index.split('-');

    _model.investmentOptionList[idx[1]].weight = Mapper.toTrim(weight);

    validateInvestmentOptionQty();

    validateInvestmentOptionSummary();
}

//Check what types of contribution allowed for customer's age
function setAgeEligibility(age) {
    if (age>=0) {
        _eligibleContribution = DateTime.eligibleContributionMatrix(
            age, _originalYourDetailsDob);
        _showRipSection = !_eligibleContribution.hidePersonal;
        if (!_showRipSection) {
            resetRipModel('');
        }
    }
}

//Retrive data coming from retrieve API
function retrieveRegularInvestmentPlan(data) {
    var rip = data.form.regularInvestmentPlan,
        userType = window.NOA ? window.NOA.userContext.userType : '';

    //set product ID
    _productId = data.productId;

    if (data.form.fundingYourProduct && data.form.fundingYourProduct.fundingSources && data.form.fundingYourProduct.fundingSources.length > 0) {
        setBankAccountsList(data.form.fundingYourProduct.fundingSources);
    }

    if (data.productId === ProductIds.SUPER) {
        //we set the DOB from your details
        if (data.form.yourDetails.dateOfBirth) {
            setOriginalYourDetailsAgeEligibility(data.form.yourDetails.dateOfBirth);
        }
        
        if (validateDob(_originalYourDetailsDob, '')) {
            setAgeEligibility(_age);
        }
    }

    if (rip) {
        if (rip.ripOption === ApplicationConstants.YesNoValues.YES) {
            validateRegularInvestmentPlan(rip.ripOption, data.productId);
        }
        if (rip.selectedBankAccount && rip.selectedBankAccount !== Constants.NOMINATE_OTHER_ACCOUNT) {
            _bankData = [];
            _bankData.push({
                accountHolder: rip.nameOfAccountHolder,
                branchNumber: rip.branchNumber,
                accountNumber: rip.bankAccount,
                value: rip.bankAccount,
                id: rip.bankAccount
            });
            _internalBankData = [];
            _internalBankData.push({
                bankAccountName: rip.nameOfAccountHolder,
                bankBsb: rip.branchNumber,
                bankAccountNumber: rip.bankAccount,
                value: rip.bankAccount,
                id: rip.bankAccount
            });

            appendNominateOtherAccount();
        }
        setSpecificBankAccounts(userType, _productId, data.form.accountType);

        var totalAllocationPercentage = 0;
        var investmentList = [];
        if (rip.investmentOptionList && rip.investmentOptionList.length > 0) {
            _.forEach(rip.investmentOptionList, function (o) {
                totalAllocationPercentage += parseFloat(o.weight.toFixed(2));
                var data = { code: o.code, id: o.id, name: o.name, weight: o.weight > 0 ? o.weight.toFixed(2) : o.weight = '', origWeight: o.origWeight > 0 ? o.origWeight.toFixed(2) : o.origWeight = '', isValid: o.isValid };
                investmentList.push(data);
            });
        }

        updateRegularInvestmentPlan({
            ripOption: rip.ripOption,
            personalContribution: rip.personalContribution > 0 ? rip.personalContribution.toFixed(2) : rip.personalContribution = '',
            spouseContribution: rip.spouseContribution > 0 ? rip.spouseContribution.toFixed(2) : rip.spouseContribution = '',
            monthlyAmountContribution: rip.monthlyAmountContribution > 0 ? rip.monthlyAmountContribution.toFixed(2) : rip.monthlyAmountContribution = '',
            selectedBankAccount: rip.selectedBankAccount,
            nameOfAccountHolder: rip.nameOfAccountHolder,
            bankAccountHeldOption: rip.bankAccountHeldOption,
            branchNumber: rip.branchNumber,
            bankAccount: rip.bankAccount,
            sameAsInvestAllocationOption: rip.sameAsInvestAllocationOption,
            investmentOptionList: investmentList,
            consumerPriceIndex: rip.consumerPriceIndex,
            totalAllocationPercentage
        });

        _model.totalContribution = _.sum([parseFloat(_model.personalContribution), parseFloat(_model.spouseContribution)]).toFixed(2);

        if (_model.selectedBankAccount !== Constants.NOMINATE_OTHER_ACCOUNT) {
            _specificBankAccounts = _bankData;
            _showBankAccountList = true;
        } else {
            _showBankAccountList = false;
            if (_bankAccountFunding) {
                _showBankAccountList = true;
            }

            _specificBankAccounts = _bankData || [];
        }

        _formError.errorList = [];
        _errorListForSummary = [];
    }
}

//To set the original investment option list
function setOriginalInvestmentOptionList(list) {
    _originalInvestmentAllocationList = list;
}

//To set the DOB and age eligibility
function setOriginalYourDetailsAgeEligibility(data) {
    var result = true;

    _showRipSection = true;
    
    if (_originalYourDetailsDob === '' && data !== _originalYourDetailsDob) {
        resetRipModel('');
    }
    
    _originalYourDetailsDob = data;
    loadDob(data);

    var isValidDob = validateDob(_originalYourDetailsDob, '');

    if (isValidDob) {

        if (_age === 75) {
            result = DateTime.isAge75Valid(new Date(), data);
        } else if (_age > 75) {
            result = false;
        }

        _showRipSection = result;

        if (!result) {
            resetRipModel('');
        }

        if (_.findIndex(_formError.errorList, function (n) { return n.message === ContentService.getContent().regularInvestmentPlan.missingDOBInline; }) > -1) {
            _.remove(_formError.errorList, function (n) { return n.message === ContentService.getContent().regularInvestmentPlan.missingDOBInline; });
            _model.ripOption = '';
        }
    }
}

//validate the date of birth
function validateDob(DOB, product) {
    var isValid = DateTime.isBirthDateValid(DOB, product);
    if (isValid) {
        _age = DateTime.getAge(new Date(), DOB);
    }

    return DateTime.isBirthDateValid(DOB, product);
}

//update Rip model
function updateRIPData(field, fieldValue) {

    var value = Mapper.toTrim(fieldValue);

    _model[field] = value;

    //we need to reset values of 
    if (field === 'selectedBankAccount' && value !== Constants.NOMINATE_OTHER_ACCOUNT) {
        if (value) {
            let bankDetailsByAccountNumber = _.filter(_specificBankAccounts, { accountNumber: value });
            let bankDetailsByAccountHolder = _.filter(_specificBankAccounts, { accountHolder: value });
            let bankDetailsByBranch = _.filter(_specificBankAccounts, { branchNumber: value });
            let bankDetails = [];
            if (bankDetailsByAccountNumber.length > 0 && bankDetailsByAccountHolder.length === 0 && bankDetailsByBranch.length === 0) {
                bankDetails = bankDetailsByAccountNumber;
            }
            if (bankDetailsByAccountNumber.length === 0  && bankDetailsByAccountHolder.length > 0 && bankDetailsByBranch.length === 0) {
                bankDetails = bankDetailsByAccountHolder;
            }
            if (bankDetailsByAccountNumber.length === 0 && bankDetailsByAccountHolder.length === 0 && bankDetailsByBranch.length > 0) {
                bankDetails = bankDetailsByBranch;
            }
            if(bankDetails && bankDetails.length > 0){
                updateRegularInvestmentPlan({
                    nameOfAccountHolder: bankDetails[0].accountHolder, bankAccountHeldOption: '', branchNumber: bankDetails[0].branchNumber, bankAccount: bankDetails[0].accountNumber
                });
            }
        } else {
            updateRegularInvestmentPlan({
                nameOfAccountHolder: '', bankAccountHeldOption: '', branchNumber: '', bankAccount: ''
            });
        }

        _.remove(_formError.errorList, { id: 'ripNameOfAccountHolderText' });
        _.remove(_formError.errorList, { id: 'ripBankAccountHeldOption' });
        _.remove(_formError.errorList, { id: 'ripBranchNumberText' });
        _.remove(_formError.errorList, { id: 'ripBankAccountText' });

        _formError.specifyBankAccountValid = true;
        _.remove(_formError.errorList, { id: 'ripNominatedOtherAccount' });

    } else if (field === 'selectedBankAccount' && value === Constants.NOMINATE_OTHER_ACCOUNT) {
        updateRegularInvestmentPlan({
            nameOfAccountHolder: '', bankAccountHeldOption: '', branchNumber: '', bankAccount: '', selectedBankAccount: Constants.NOMINATE_OTHER_ACCOUNT
        });
        _formError.errorList = [];
        _formError.specifyBankAccountValid = true;
    }

    if (_model.nameOfAccountHolder || _model.bankAccountHeldOption || _model.branchNumber || _model.bankAccount) {
        _formError.specifyBankAccountValid = true;
        _.remove(_formError.errorList, { id: 'ripNominatedOtherAccount' });
    }

    validateFields(field, value);
}

//create table for bank accounts
function createTableBankAccounts() {
    var copytextRip = ContentService.getContent().regularInvestmentPlan;
    _bankData = [];
    // push from funding
    if (_bankAccountFunding) {

        var value = '',
            id = '';
        if (_bankAccountFunding.accountNumber) {
            value = _bankAccountFunding.accountNumber;
            id = _bankAccountFunding.accountNumber;
        }
        else if (!_bankAccountFunding.accountNumber && _bankAccountFunding.accountHolderName) {
            value = _bankAccountFunding.accountHolderName;
            id = _bankAccountFunding.accountHolderName;
        }
        else if (!_bankAccountFunding.accountNumber && !_bankAccountFunding.accountHolderName && _bankAccountFunding.branchNumber) {
            value = _bankAccountFunding.branchNumber;
            id = _bankAccountFunding.branchNumber;
        }
        _bankData.unshift({
            accountHolder: _bankAccountFunding.accountHolderName,
            branchNumber: _bankAccountFunding.branchNumber,
            accountNumber: _bankAccountFunding.accountNumber,
            value: value,
            id: id
        });
    }
    // push from internal bank
    if (_internalBankData.length > 0) {
        _.forEach(_internalBankData,
            function (b) {
                var bankAccount = {
                    accountHolder: b.bankAccountName,
                    branchNumber: b.bankBsb,
                    accountNumber: b.bankAccountNumber,
                    value: b.bankAccountNumber,
                    id: b.bankAccountNumber
                };
                if (bankAccount.accountHolder && bankAccount.accountNumber) {
                    _bankData.push(bankAccount);
                }
            });
    }
    // push nominate other account
    if (_bankData.length > 0) {
        appendNominateOtherAccount();
        _showBankAccountList = true;
        _model.selectedBankAccount = '';
        if (_bankAccountFunding) {
            _model.selectedBankAccount = _bankData[0].accountNumber;
        }
    }       
    else {
        _showBankAccountList = false;
    }
    _specificBankAccounts = _bankData;
    // if selected bank account is from funding, save to model
    if (_bankAccountFunding) {
        if (_.filter(_specificBankAccounts, { selectedBankAccount: _specificBankAccounts[0].accountNumber })) {
            updateRIPData('selectedBankAccount', _bankAccountFunding.accountNumber);
            updateRIPData('bankAccountHeldOption', _bankAccountFunding.bankAccountHeldOption);
            _.remove(_formError.errorList, { message: copytextRip.monthlyContributionEmptyInline });
        }
    } 
}

//set bank account information
function setBankAccountDetails(data) {
    if (window.NOA.userContext.userType === ApplicationConstants.UserTypes.INVESTOR && data) {
        _internalBankData = data;
    }  
}

function appendNominateOtherAccount() {
    _bankData.push({
    accountHolder: 'Nominate another account',
    branchNumber: '',
    accountNumber: '',
    value: Constants.NOMINATE_OTHER_ACCOUNT,
    id: Constants.NOMINATE_OTHER_ACCOUNT
});
}

//set the product Id
function setProductId(Id) {
    _productId = Id;
    resetRipModel('');
    _errorListForSummary = [];
    _formError.errorList = [];
}

function crossSectionInvestmentAllocationReset() {
    // reset total allocation percentage
    updateRegularInvestmentPlan({ totalAllocationPercentage: '0.00' });
    _.forEach(_model.investmentOptionList, function (o) { o.weight = ''; });
    // reset checkbox
    updateRegularInvestmentPlan({ sameAsInvestAllocationOption: ApplicationConstants.YesNoValues.NO });
    _.remove(_formError.errorList, function (o) {  return _.startsWith(o.id, Constants.RIP_INV_OPT_PREFIX); });
}

function removeSetUpErrorMessage(){
    _.remove(_errorListForSummary, function (o) {  return o.id === 'regularInvestPlanOption' });
    return _.remove(_formError.errorList, function (o) {  return o.id === 'regularInvestPlanOption' });
}

function validateIATotalPercentage(){
    var total = _.sum(_originalInvestmentAllocationList, function (data) { return parseFloat(data.weight) });
    if (total !== 100){
        const ripContent = ContentService.getContent().regularInvestmentPlan;
        throwErrorMessage('regularInvestPlanOption', ripContent.not100PercentInvestAllocationInline, ripContent.investAllocation100Summary);
        _setupError = false;
        return false;
    }
    _setupError = true;
    return true;
}

function validateRipIA(){
    const ripContent = ContentService.getContent().regularInvestmentPlan;
    if (_originalInvestmentAllocationList.length === 0){
        throwErrorMessage('regularInvestPlanOption', ripContent.noInvestmentAllocationInline, ripContent.investAllocationSetupSummary);
        _setupError = false;
        return false;
    }
    else if (_model.investmentOptionList.length === 0) {
        throwErrorMessage('regularInvestPlanOption', ripContent.investAllocationOtherThanTermDepositInline, ripContent.investAllocationSetupSummary);
        _setupError = false;
        return false;
    }
    _setupError = true;
    return true;
}


function revalidateIATotalInvestment(){
    // Revalidate IA total percentage only when investments is more than 0
    if (_originalInvestmentAllocationList.length > 0){
        var ripError = removeSetUpErrorMessage();
        const ripContent = ContentService.getContent().regularInvestmentPlan;
        // Check for investment allocation percentage only when the current set-up error is total percentage error.
        if (ripError && ripError[0] && ripError[0].message === ripContent.not100PercentInvestAllocationInline){
            return validateIATotalPercentage();
        }    
    }
    
    return true;
}

// cross section investment allocation
function validateInvestmentAllocation() {
    if (_model.ripOption === ApplicationConstants.YesNoValues.YES && _showRipSection) {
        if (_productId === ProductIds.INVESTMENT ||
            (_productId === ProductIds.SUPER && _originalYourDetailsDob && _age <= 75)) {
            setSpecificBankAccounts(_userType, _productId, _accountType);
            if (_productId === ProductIds.SUPER) {
                _eligibleContribution = DateTime
                    .eligibleContributionMatrix(
                        _age, _originalYourDetailsDob);
            }
            // Check for investment allocation total percentage when all investment options have been removed and
            // user decieded to add another
            if (_prevOriginalInvestmentAllocationList.length === 0 && _originalInvestmentAllocationList.length > 0){
                removeSetUpErrorMessage();
                validateIATotalPercentage();
            }
            // Reset RIP investment option table when investment options in IA Section has been added or removed
            else if (_prevOriginalInvestmentAllocationList.length !== _originalInvestmentAllocationList.length) {
                crossSectionInvestmentAllocationReset();
                if (revalidateIATotalInvestment()){
                    removeSetUpErrorMessage();
                    validateRipIA();
                }
            }
            // When investment option weight has been changed
            else if (!_.isEqual(_prevOriginalInvestmentAllocationList, _originalInvestmentAllocationList)) {
                if (revalidateIATotalInvestment()){
                    removeSetUpErrorMessage();
                    validateRipIA();    
                }
                if (_model.sameAsInvestAllocationOption === ApplicationConstants.YesNoValues.YES)
                {
                    // Set the RIP investment table percentage the same as investment allocation section.
                    monthlyAmountAllocation(_model.sameAsInvestAllocationOption);
                }
            }
        }
        if (!_setupError) {
            resetRipFormModel();
        }
    }
}

var RegularInvestmentPlanStore = assign({}, EventEmitter.prototype, {
    emitChange: function () {
        this.emit(CHANGE_EVENT);
    },
    addChangeListener: function (callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function (callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    getSetupRIPErrorState: function () {
        return _setupError;
    },
    getEligibleContribution: function () {
        return _eligibleContribution;
    },
    getRegInvstPlanModel: function () {
        return getModelData();
    },
    getSpecificBankAccounts: function () {
        return _specificBankAccounts;
    },
    getFormError: function () {
        return _formError;
    },
    getErrorList: function () {
        return _errorListForSummary;
    },
    getOrigInvestmentOption: function () {
        return _originalInvestmentAllocationList;
    },
    showBankAccountList: function () {
        return _showBankAccountList;
    },
    showRipSection: function () {
        return _showRipSection;
    }
});

RegularInvestmentPlanStore.dispatchToken = AppDispatcher.register(function (action) {

    switch (action.actionType) {
        case ActionTypes.VALIDATE_REGULAR_INVESTMENT_PLAN:
            setProductId(action.productId);
            validateRegularInvestmentPlan(action.ripOption, action.productId, action.userType, action.accountType);
            break;
        case ActionTypes.UPDATE_RIP_INVEST_ALLOCATION_QTY:
            updateRIPInvestAllocationQty(action.index, action.weight);
            break;
        case ActionTypes.MONTHLY_AMOUNT_ALLOCATION:
            monthlyAmountAllocation(action.option);
            break;
        case ApplicationConstants.ActionTypes.SEND_INVESTMENT_OPTIONS:
            setOriginalInvestmentOptionList(action.investmentOptionList);
            generateRIPInvestmentOptionList();
            validateInvestmentAllocation();
            _prevOriginalInvestmentAllocationList = _.cloneDeep(_originalInvestmentAllocationList);
            break;
        case ApplicationConstants.ActionTypes.APPLICATION_RETRIEVE_SUCCESS:
            retrieveRegularInvestmentPlan(action.applicationData);
            break;
        case ApplicationConstants.ActionTypes.SEND_YOUR_DETAIL_DOB:
            setOriginalYourDetailsAgeEligibility(action.dob);
            break;
        case ActionTypes.UPDATE_RIP_DATA:
            updateRIPData(action.field, action.value);
            break;
        case ApplicationConstants.ActionTypes.SEND_BANK_ACCOUNT_DETAILS:
            setBankAccountDetails(action.data);
            break;
        case ActionTypes.UPDATE_REGULAR_INVESTMENT_PLAN:
            updateRegularInvestmentPlan(action.data);
            break;
        case ApplicationConstants.ActionTypes.VALIDATE_APPLICATION:
            validateRequiredFields();
            break;
        case ApplicationConstants.ActionTypes.NEW_APPLICATION_INITIALISED:
            setProductId(action.productId);
            prePopulateWithExistingClientIfAny();
            break;
        case ApplicationConstants.ActionTypes.IS_FUNDING_SUMMARY:
            setBankAccountsList(action.summary);
            break;
        case SelectCustomerActionsTypes.CLIENT_RETRIEVE_COMPLETED:
            setClient(action.client);
            break;
        default:
            return true;
    }
    RegularInvestmentPlanStore.emitChange();
    return true;
});

module.exports = RegularInvestmentPlanStore;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./stores/RegularInvestmentPlanStore.js